__turbopack_context__.v({
  "formContact": "twoFactorAuthenticationForm-module-scss-module__eqts8q__formContact",
  "formError": "twoFactorAuthenticationForm-module-scss-module__eqts8q__formError",
  "formIcon": "twoFactorAuthenticationForm-module-scss-module__eqts8q__formIcon",
  "formInput": "twoFactorAuthenticationForm-module-scss-module__eqts8q__formInput",
  "formInputError": "twoFactorAuthenticationForm-module-scss-module__eqts8q__formInputError",
  "formWrapper": "twoFactorAuthenticationForm-module-scss-module__eqts8q__formWrapper",
  "inputWrapper": "twoFactorAuthenticationForm-module-scss-module__eqts8q__inputWrapper",
  "resendButton": "twoFactorAuthenticationForm-module-scss-module__eqts8q__resendButton",
  "resendWrapper": "twoFactorAuthenticationForm-module-scss-module__eqts8q__resendWrapper",
});
